import { SyntheticEvent } from 'react';

import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';
import { scrollToTopWithCallback } from 'shared/utils/scrollToTopWithCallback';

import { Pagination } from './Pagination';
import { usePagination } from './internal/hooks/usePagination';
import { PaginationItem } from './types';

type PaginationControllerProps = {
  maxPage: number | null;
  offersPerPage: number;
  page: number;
  totalOffers: number;
  onPageClick(pageButton: PaginationItem): void;
};

export const PaginationController = memoWithDisplayName<PaginationControllerProps>(props => {
  const { offersPerPage, totalOffers, page, maxPage, onPageClick } = props;

  const { pages, nextPage, prevPage } = usePagination({ maxPage, offersPerPage, page, totalOffers });

  if (!pages.length) {
    return null;
  }

  const handleClickPagination = (_e: SyntheticEvent<HTMLButtonElement>, pageButton: PaginationItem): void => {
    scrollToTopWithCallback(() => {
      onPageClick(pageButton);
    });
  };

  return <Pagination nextButton={nextPage} pages={pages} prevButton={prevPage} onClick={handleClickPagination} />;
}, 'PaginationController');
